import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51b2ed6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap_screen" }
const _hoisted_2 = { class: "status_bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 나의 커스텀보이스 ", -1))
const _hoisted_4 = { class: "wrap_chat_screen" }
const _hoisted_5 = { class: "form_box" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_info" }, [
  /*#__PURE__*/_createElementVNode("div", null, "마이크 버튼을 눌러 자신의 음성을 녹음하고"),
  /*#__PURE__*/_createElementVNode("div", null, "'커스텀보이스 등록'버튼을 눌러보세요.")
], -1))
const _hoisted_7 = { class: "wrap_rec" }
const _hoisted_8 = { class: "rec" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "wrap_next" }
const _hoisted_11 = { class: "wrap_next" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "wrap_info" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "warning" }, " 🙏 커스텀 보이스를 등록해야 다른 사용자와 채팅 시 내 목소리를 들려줄 수 있습니다. ")
], -1))

import { ref } from 'vue';
import {
  tabStore,
  userStore,
  tutorialStore,
} from '../stores/storeAuth';
import { useAudioStore } from '../stores/storeAudio';
import {
  postSpeakerUser,
  postStreamsUser,
} from '@apis/voicechat';
import { postStreams } from '@apis/streams';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomVoiceRead',
  setup(__props) {

const isListening = ref(false);
const speakerBase64Result = ref('');
let mediaRecorder: MediaRecorder | null;
let audioChunks: Blob[] = [];
const audioPlayer = ref<HTMLAudioElement | null>(null);
const message = ref('');
const sampleText = ref('동해 물과 백두산이 마르고 닳도록 하느님이 보우하사 우리나라 만세. 무궁화 삼천리 화려 강산. 대한 사람 대한으로 길이 보전하세.');
const userData = userStore();
const tabData = tabStore();

const sendMessage = () => {
  console.log('sending messages', message);
};

const handleEnterKey = () => {
  sendMessage();
  message.value = '';
};

// speaker
const speakerUser = async (params: any) => {
  try {
    console.log(params);
    const result = await postSpeakerUser(params);
    console.log(result.data, '💛💛');
    // speakerBase64Result.value = result.data.speaker_base64_string;
  } catch (error) {
    alert(error);
  }
};

// stream
const streamUser = async () => {
  const params = {
    quest: sampleText.value,
    user_id: userData.userId,
  };
  console.log(params, 'streams/user quest, user id 일케 ');
  try {
    // const iterator = postStreams('guest', params.quest, params.speaker_base64_string);
    // let result;streamGuest
    // let i = 0;
    // do {
    //   result = iterator.next();
    //   i += 1;
    //   console.log(`iterator(${i}):`, result.value);
    // } while (!result.done);
    const audioStore = useAudioStore();
    console.log('call stream user', params.quest, userData.userId);
    postStreams('user', params.quest, userData.userId);
  } catch (error) {
    console.log(error);
  }
};

const startRecording = () => {
  isListening.value = true;

  navigator.mediaDevices.getUserMedia({ audio: true })
    .then((stream) => {
      mediaRecorder = new MediaRecorder(stream);

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunks.push(event.data);
        }
      };

      mediaRecorder.onstop = () => {
        const audioBlob = new Blob(audioChunks, { type: 'audio/wav' });

        const reader = new FileReader();
        reader.onloadend = async () => {
          // base64 String
          const base64String = reader.result as string;
          const base64Data = base64String.split(',')[1];
          console.log(base64Data);

          // speaker/guest 호출
          const params = {
            audio_base64_string: base64Data,
            user_id: userData.userId,
          };
          await speakerUser(params);

          // 오디오 재생
          if (audioPlayer.value) {
            audioPlayer.value.src = base64String;
          }
        };

        reader.readAsDataURL(audioBlob);

        // 정리
        audioChunks = [];
        mediaRecorder = null;
        isListening.value = false; // 녹음이 중지될 때 isListening을 false로 설정
      };

      mediaRecorder.start();
    })
    .catch((error) => {
      console.error('마이크에 접근 중 오류 발생:', error);
      isListening.value = false;
    });
};

const stopRecording = () => {
  isListening.value = false;
  if (mediaRecorder) {
    mediaRecorder.stop();
  }
};

const showMobileMenu = () => {
  tabData.sideMenu = true;
};


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, {
        class: "chevron",
        icon: "fa-solid fa-bars",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showMobileMenu()))
      }),
      _hoisted_3
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (!isListening.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "button_rec_mic",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (startRecording()))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "rec_icon",
                      icon: "fa-solid fa-microphone"
                    })
                  ]))
                : _createCommentVNode("", true),
              (isListening.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "button_rec_stop",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (stopRecording()))
                  }, [
                    _createVNode(_component_font_awesome_icon, {
                      class: "rec_icon",
                      icon: "fa-solid fa-square"
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            (isListening.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " 녹음 중입니다. 정지버튼을 눌러 녹음을 완료하세요. "))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", null, [
              _createElementVNode("audio", {
                ref_key: "audioPlayer",
                ref: audioPlayer,
                controls: ""
              }, null, 512)
            ])
          ]),
          _createElementVNode("div", null, [
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((sampleText).value = $event)),
              class: "sample_text"
            }, null, 512), [
              [_vModelText, sampleText.value]
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "button_okay",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (streamUser()))
              }, " 커스텀보이스 등록 ")
            ]),
            _hoisted_12
          ])
        ])
      ])
    ])
  ]))
}
}

})